import { call, put, takeLatest } from 'redux-saga/effects';
import HeroAccountAPI from 'api-services/HeroAccountApi';
import { isSuccessResponse } from 'api-services/types/guards';
import { checkUserHelper } from '../utils/helperSagas';
import { SET_DATA_OPTOUT } from './actionTypes';
import { setDataOptoutDone, setDataOptoutError } from './actionCreators';
import { logout } from '../auth/actionCreators';
export function* setDataOptout(constAccessParams, action) {
    const newAccessParams = yield call(checkUserHelper, constAccessParams);
    const result = yield call(HeroAccountAPI.setDataOptout, newAccessParams, action.data);
    if (isSuccessResponse(result)) {
        yield put(setDataOptoutDone(action.data));
    }
    else if (result.statusCode === 4) {
        yield put(logout());
    }
    else {
        yield put(setDataOptoutError(result.msg));
    }
}
export function* watchSetDataOptoutCalls(constAccessParams) {
    yield takeLatest(SET_DATA_OPTOUT, setDataOptout, constAccessParams);
}
//# sourceMappingURL=saga.js.map